/* unplugin-vue-components disabled */import script from "./open_wxxcx.vue?vue&type=script&setup=true&lang=js"
export * from "./open_wxxcx.vue?vue&type=script&setup=true&lang=js"

import "./open_wxxcx.vue?vue&type=style&index=0&id=06afd4dc&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06afd4dc"]])

export default __exports__